// extracted by mini-css-extract-plugin
module.exports = {"avisosPortada":"avisos-module--avisosPortada---CFXL","avisosContent":"avisos-module--avisosContent--2Jy0y"};